import { useGame, useLobbyGame } from "~/app";
import {
  XButton,
  XCard,
  XResourceWithAmount,
  XTypography,
} from "~/jsx/components/design";
import { useActions, useViewingPlayerOpt } from "~/jsx/hook";
import { FontSize, Sizes, Spacing } from "~/jsx/theme";
import { XTechPanel } from "./XTechPanel";
import { getLobbyGameParams } from "~/business";

export const XShop = () => {
  const { game } = useGame();
  const { onShopCardClickFactory } = useActions();
  const viewingPlayer = useViewingPlayerOpt();
  const { onEndTurn } = useActions();
  const { shop, ArrakisLiaisonCard, TSMFCard } = game;
  const { reservedShopCards, techNegociators } = viewingPlayer ?? {};
  const lobbyGame = useLobbyGame();
  const { useIxExtension = false } = getLobbyGameParams(lobbyGame) ?? {};

  return (
    <div>
      {viewingPlayer && (
        <XTypography
          style={{ fontSize: FontSize.px18, marginBottom: Spacing.px12 }}
        >
          Points available:{" "}
          <XResourceWithAmount
            type="influence"
            amount={viewingPlayer.influencePoints}
            width={24}
            style={{ verticalAlign: "middle" }}
          />
        </XTypography>
      )}
      <div style={{ display: "flex", gap: 10 }}>
        {shop.pile.map((card) => (
          <XCard
            key={card.id}
            card={card}
            width={Sizes.cardWidths.normal}
            onClick={onShopCardClickFactory(card)}
          />
        ))}
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
        {[ArrakisLiaisonCard, TSMFCard].map((card) => (
          <XCard
            key={card.id}
            card={card}
            width={Sizes.cardWidths.normal}
            onClick={onShopCardClickFactory(card)}
          />
        ))}
        {(reservedShopCards?.pile ?? []).map(({ card, discount }) => {
          return (
            <div key={card.id}>
              <XCard
                card={card}
                width={Sizes.cardWidths.normal}
                onClick={onShopCardClickFactory(card)}
              />
              {discount > 0 && (
                <XTypography
                  style={{ fontSize: 18, textAlign: "center", marginTop: 8 }}
                >
                  Discount:{" "}
                  <XResourceWithAmount
                    amount={discount}
                    type="influence"
                    width={32}
                    style={{ verticalAlign: "middle" }}
                  />
                </XTypography>
              )}
            </div>
          );
        })}
      </div>
      <div style={{ marginTop: Spacing.px12, marginBottom: Spacing.px8 }}>
        {useIxExtension && techNegociators && (
          <XResourceWithAmount
            amount={techNegociators.length}
            width={32}
            type="techNegociator"
            variant="separated"
            style={{ marginBottom: Spacing.px8 }}
          />
        )}
        <XTechPanel />
      </div>
      <div
        style={{
          width: "fit-content",
          marginTop: 24,
          opacity: onEndTurn ? 1 : 0,
        }}
      >
        <XButton onClick={onEndTurn} style={{ padding: 20 }}>
          End turn
        </XButton>
      </div>
    </div>
  );
};
